import { SKILL_IDS } from "../constants.ts";
import type { SkillDefinition } from "../model.ts";

export const SKILL_GRAPH_VERSION = "r20-skills-v1";

export const SKILLS: readonly SkillDefinition[] = [
  {
    id: SKILL_IDS.ZERO,
    kind: "FOUNDATION",
    numberRange: 20,
    label: "Nulrelaties",
    description: "Begrijpen wat optellen met nul, aftrekken van nul en n min n doen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.SPLIT_5,
    kind: "FOUNDATION",
    numberRange: 20,
    label: "Splitsen tot 5",
    description: "Getallen van 2 tot en met 5 flexibel splitsen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.SPLIT_10,
    kind: "FOUNDATION",
    numberRange: 20,
    label: "Splitsen tot 10",
    description: "Getallen van 6 tot en met 10 flexibel splitsen.",
    prerequisiteIds: [SKILL_IDS.SPLIT_5],
  },
  {
    id: SKILL_IDS.TEEN_STRUCTURE,
    kind: "FOUNDATION",
    numberRange: 20,
    label: "Tien en nog iets",
    description: "Getallen van 11 tot en met 20 begrijpen als 10 plus een rest.",
    prerequisiteIds: [SKILL_IDS.SPLIT_10],
  },
  {
    id: SKILL_IDS.PLUS_MINUS_1,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Eén meer en één minder",
    description: "Buurgetallen direct herkennen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.PLUS_MINUS_2,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Twee meer en twee minder",
    description: "Twee stappen als één eenheid gebruiken.",
    // The taught COUNT_ON/COUNT_BACK routes are the safety gate. Requiring 75%
    // coverage of every one-step direction first made the alpha needlessly flat.
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.DOUBLES,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Dubbelen",
    description: "Dubbelen van 1 plus 1 tot en met 10 plus 10 en hun inverses.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.MAKE_10,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Vriendjes van 10",
    description: "De vijf positieve factfamilies die samen 10 maken.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.NEAR_DOUBLES,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Bijna dubbelen",
    description: "Een bekend dubbel gebruiken en één aanpassen.",
    prerequisiteIds: [SKILL_IDS.DOUBLES],
  },
  {
    id: SKILL_IDS.BASIC_TO_10,
    kind: "ANCHOR",
    numberRange: 20,
    label: "Plus en min binnen 10",
    description: "De resterende feiten binnen 10 zelfstandig en efficiënt oplossen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.COMMUTATIVE,
    kind: "RELATION",
    numberRange: 20,
    label: "Omwisselen bij optellen",
    description: "Begrijpen dat a plus b hetzelfde totaal heeft als b plus a.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.INVERSE,
    kind: "RELATION",
    numberRange: 20,
    label: "Plus en min horen bij elkaar",
    description: "Optel- en aftrekfeiten binnen één factfamilie verbinden.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.TEEN_NO_BRIDGE,
    kind: "TARGET",
    numberRange: 20,
    label: "Rekenen tussen 10 en 20",
    description: "Een bekend feit binnen 10 toepassen zonder een tiental te passeren.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.CROSS_10_ADD,
    kind: "TARGET",
    numberRange: 20,
    label: "Over 10 optellen",
    description: "Eerst 10 maken en daarna de rest optellen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.CROSS_10_SUB,
    kind: "TARGET",
    numberRange: 20,
    label: "Over 10 aftrekken",
    description: "Eerst teruggaan naar 10 en daarna de rest aftrekken.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.AUTOMATE,
    kind: "MASTERY",
    numberRange: 20,
    label: "Automatiseren",
    description: "Strategisch rekenen betrouwbaar en efficiënt laten verlopen.",
    prerequisiteIds: [],
  },
  {
    id: SKILL_IDS.MEMORIZE,
    kind: "MASTERY",
    numberRange: 20,
    label: "Direct weten",
    description: "Feiten rechtstreeks uit het geheugen ophalen.",
    prerequisiteIds: [SKILL_IDS.AUTOMATE],
  },
  {
    id: SKILL_IDS.MAINTAIN,
    kind: "MASTERY",
    numberRange: 20,
    label: "Blijven weten",
    description: "Beheersing met gespreide herhaling onderhouden.",
    prerequisiteIds: [SKILL_IDS.MEMORIZE],
  },
  {
    id: SKILL_IDS.TRANSFER,
    kind: "TRANSFER",
    numberRange: 20,
    label: "Slim verder rekenen",
    description: "Bewezen kennis toepassen in een groter getalgebied.",
    prerequisiteIds: [],
  },
];

export const SKILL_BY_ID: ReadonlyMap<string, SkillDefinition> = new Map(
  SKILLS.map((skill) => [skill.id, skill]),
);
